import React, { useCallback } from 'react'
import { SuperForm, FormDataStoreProvider } from '@mes-amis/super-form'
import '@mes-amis/super-form/styles.css'

// Interactive, throwaway preview of a super form definition. Field values live
// only in the in-browser FormDataStore (uncontrolled mode) — nothing is saved —
// so you can click through radios, checkboxes, and dependent fields.
const ReactSuperFormPreview = ({ definition, client, readonly }) => {
  const handleChange = useCallback(() => {}, [])

  if (!definition || !definition.form) {
    return <div className="text-muted p-3">Save a form definition to preview it here.</div>
  }

  return (
    <div className="p-2">
      <FormDataStoreProvider initialFormData={{}} onChange={handleChange}>
        <SuperForm definition={definition} client={client} readonly={!!readonly} onChange={handleChange} />
      </FormDataStoreProvider>
    </div>
  )
}

export default ReactSuperFormPreview
